import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import DataSource from "../../../types/DataSource"

export interface componentProps {
    item: DataSource
}

const ViewItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    const dataSourceSyncsCount: number  = item !== undefined ? item.dataSourceSyncs?.length || 0 : 0

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            <IonItem button={dataSourceSyncsCount > 0}
                     detail={dataSourceSyncsCount > 0}
                     lines="full"
                     routerLink={'/data-sources/' + item.id + '/data-source-syncs'}>
                <IonLabel>{t('data-source-syncs.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{dataSourceSyncsCount || '-'}</IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ViewItemGroupInfo